import api from "../..";
import type { PostSkyroomParams } from "./types";

export const postSkyroom = async ({ body }: PostSkyroomParams): Promise<boolean> => {

  return await api.post("/skyroom/", body)
  .then(() => true).
  catch(() => false); 
};